import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

export interface MeterSensorGroup {
  sensorGroupId: number;
  sensorGroupName: string;
  sensorGroupMetronId: string | null;
  source: string | null;
  waterscopeType: string | null;
  propertyId: number | null;
  propertyName: string | null;
  childSensorGroupId: number | null;
  childSensorGroupName: string | null;
  parentSensorGroupId: number | null;
  parentSensorGroupName: string | null;
}

export interface MeterSensorGroupProperty {
  propertyId: number;
  propertyName: string;
  propertyMetronId: string | null;
  customerId: number | null;
  customerName: string | null;
  sensorGroupId: number;
  sensorGroupName: string;
  masterSensorGroupId: number | null;
  masterSensorGroupName: string | null;
}

interface MeterSensorGroupsResponse {
  sensorGroups: MeterSensorGroup[];
  properties: MeterSensorGroupProperty[];
}

export function useMeterSensorGroups(sensorId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-sensor-groups', sensorId],
    queryFn: () => apiClient.get<MeterSensorGroupsResponse>(`meters/${sensorId}/sensor-groups`),
    enabled: !!sensorId,
  });
}
